//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import eventBus from "../services/eventBus";
import ContentCard from "./Media/ContentCard.vue";
import AddMediaButton from "./Media/AddMediaButton.vue";
import sharedMethods from "../sharedMethods.js";
import { Container } from "vue-smooth-dnd";
import DeleteMediaModal from "./Media/DeleteMediaModal.vue";

export default {
  components: { ContentCard, AddMediaButton, Container },
  props: ["asPage"],
  computed: {
    ...mapGetters(["allMediaFiles", "allUserPlaylists", "getDeviceAssignedPlaylistsByID", "getApi", "getHost", "filteredContent"]),
    sharedMethods() {
      return sharedMethods;
    },
  },

  data() {
    return {
      info: [],
      random: 1,
      secretMessage: "",
      processing: false,
      loading: false,
      username: "",
      uploadPercentage: "",
      filename: "",
      alert: false,
      delContent: "",
      canDel: false,
      inUsePl: [],
      searchQuery: "",
      host: "",
      api: "",
      modalEditContent: false,
      toEditContent: "",
      accID: this.$store.getters.getUser.AccID,
      dropPlaceholderOptions: {
        className: "drop-preview",
        animationDuration: "150",
        showOnTop: true,
      },
      multiSelectOn: false,
      selectedItems: [],
    };
  },
  mounted() {
    this.fetchMediaFiles();
  },

  async created() {
    if (!this.$store.getters.isLoggedIn && this.$router.currentRoute.path !== "/login") {
      this.$router.push("/login");
    }

    this.username = this.$store.getters.getUser.username;
    this.api = this.getApi;
    this.host = this.getHost;
  },

  methods: {
    ...mapActions(["fetchMediaFiles", "removePlaylistFromDevice", "checkIfContentIsInAPlaylist"]),

    onMultiItemSelected(cardContent) {
      this.selectedItems.push(cardContent);

      setTimeout(() => {
        this.multiSelectOn = true;
      }, 200);
    },

    onMultiItemDeselected(cardContent) {
      this.selectedItems.splice(
        this.selectedItems.findIndex((i) => i.id === cardContent.id),
        1
      );

      if (this.selectedItems.length === 0) {
        this.multiSelectOn = false;
      }
    },

    deleteSelection() {
      const contentIds = [];
      this.selectedItems.forEach((item) => {
        contentIds.push(item.id);
      });

      this.checkIfContentIsInAPlaylist(contentIds).then((response) => {
        const inUsePl = response.data;

        const selectedItems = JSON.parse(JSON.stringify(this.selectedItems));
        sharedMethods
          .createDialog({
            component: DeleteMediaModal,
            root: this,
            inUsePl: inUsePl,
            contentsToDelete: selectedItems,
          })
          .onOk(() => {
            console.log("ON OK");
            this.multiSelectOn = false;
            this.selectedItems = [];
          });
      });
    },

    onDrop(event) {
      this.$emit("drop", event);
    },
    getChildPayload(index) {
      if (this.multiSelectOn) {
        return this.selectedItems;
      } else {
        return this.filteredContent(this.searchQuery)[index];
      }
    },
    logout() {
      this.$store.dispatch("logout");
      if (this.$router.currentRoute.path !== "/login") {
        this.$router.push("/login");
      }
    },

    chooseFiles: function() {
      eventBus.$emit("chooseFilesForUpload");
    },
    UploadNotify() {
      sharedMethods.errorNotify("File is too big. Please use files <500mb");
    },
  },
};
